import script from "./CourseRating.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseRating.vue?vue&type=script&setup=true&lang=js"

import "./CourseRating.vue?vue&type=style&index=0&id=a503f2c4&scoped=true&lang=scss"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a503f2c4"]])

export default __exports__